import Service from "../../../Services/index";
import moment from "moment"

const FactoryEmployeeSale = {
    namespaced: true,
    state: {
        form : {
            employee_id : '',
            employee : '',
            rc_number : '',
            date : '',
            total : '',
            amount : '',
            details : [
                {
                    factory_id : '',
                    factory : '',
                    quantity : '',
                    price : '',
                    total : '',
                }
            ]
        }
    },
    mutations: {
        SET_FORM_DATA:(state,res)=>{
            state.form = res;
        },
        CLEAR_DATA : (state,no) =>{
            let date = moment().format('YYYY-MM-DD');
            state.form = {
                employee_id : '',
                employee : '',
                rc_number : no,
                date : date,
                total : '',
                amount : '',
                details : [
                    {
                        factory_id : '',
                        quantity : '',
                        price : '',
                        total : '',
                    }
                ]
            }
        },
        ADD_DATA_ARRAY : state=>{
            state.form.details = [
                ...state.form.details,
                {
                    factory_id : '',
                    quantity : '',
                    price : '',
                    total : '',
                }
            ]
        },
        REMOVE_DATA_ARRAY : (state,index)=>{
            state.form.details = state.form.details.filter(
                (detail, itemIndex) => index !== itemIndex
            );
        }
    },
    actions: {
        getFactoryEmployeeSale({commit}, {page,data}){
            return Service.factoryEmployeeSale.getFactoryEmployeeSale(page,data);
        },
        showFactoryEmployeeSale({commit},id){
            return Service.factoryEmployeeSale.showFactoryEmployeeSale(id);
        },
        saveFactoryEmployeeSale({commit},{id,data}){
            if(id){
                return Service.factoryEmployeeSale.updateFactoryEmployeeSale(id,data);
            }else{
                return Service.factoryEmployeeSale.createFactoryEmployeeSale(data);
            }
        },
        deleteFactoryEmployeeSale({commit},id){
            return Service.factoryEmployeeSale.deleteFactoryEmployeeSale(id);
        },
        searchFactoryEmployeeSale({commit}){

        },
        clearFormData({commit}){
            return Service.factoryEmployeeSale.generateRCNumber().then(res=>{
                commit('CLEAR_DATA',res);
            });

        },
        setFormData({commit},data){
            commit('SET_FORM_DATA',data);
        },
        addData({commit}){
            commit('ADD_DATA_ARRAY');
        },
        removeData({commit},index){
            commit('REMOVE_DATA_ARRAY',index);
        },
    }
};
export default FactoryEmployeeSale;
